/*
 * UCalgary Global Alert
 *
 * This script requests alerts from https://www.ucalgary.ca/feeds/alerts (the
 * Global Alert originator), and inserts the alert message into the beginning
 * of the <header> when they are available.
 *
 * When someone minimizes the Alert, the script will set a 24hr snooze cookie.
 */

(function ($, Drupal, drupalSettings, cookies) {
  'use strict';

  /**
   * Generate the alert from template.
   *
   * @return string
   */
  function generateAlert(site_alert) {
    return '<div id="global-alert" data-site-alert-id="' + site_alert.ucws_site_alert_id + '"' +
         'data-site-alert-timestamp="' + site_alert.ucws_site_alert_timestamp + '"' +
         'class="row ' + site_alert.ucws_site_alert_bgcolour + '">' +
      '<div class="container">' +
        '<div class="row controls">' +
          '<div class="col-12">' +
            '<div class="btn-toolbar">' +
              '<div class="btn-group">' +
                '<a id="alert-toggle" class="btn btn-rounded btn-tab" type="button">' +
                  '<span class="visually-hidden">Toggle Site Alert Message</span>' +
                  '<span aria-hidden="true">' +
                    '<span class="ucws-icon ucws-icon-close"></span>' +
                    '<span class="ucws-icon ucws-icon-exclamation"></span>' +
                  '</span>' +
                '</a>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="row content">' +
          '<div class="col-12">' +
            '<div class="alert-message">' +
              '<p>' +
                '<span class="message">' + site_alert.ucws_site_alert_message + '</span> ' +
                '<span class="link">' + site_alert.ucws_site_alert_link + '</span>' +
              '</p>' +
            '</div>' +
            '<div class="alert-timestamp">' +
              '<p>' +
                '<span class="date">' + site_alert.ucws_site_alert_date + '</span>' +
                '<span class="time">' + site_alert.ucws_site_alert_time + '</span>' +
              '</p>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  // Use the appropriate environment related feed url.
  var alertFeedUrl = 'https://live-ucalgary.ucalgary.ca/feeds/alerts';
  if (window.location.hostname.indexOf('staging-') > -1) {
    alertFeedUrl = alertFeedUrl.replace(/live-/, 'staging-');
  }
  else if (window.location.hostname.indexOf('.docker') > -1) {
    alertFeedUrl = alertFeedUrl.replace(/^.*:\/\/.+?\//, '/');
  }

  $.getJSON(alertFeedUrl, function (data) {

    if (data.length) {
      // Cookie settings.
      var cookieName = 'ucws-alert';
      var cookieHidden = 'ucws-alert-dismissed';
      var eventCategory = 'Site Alert';

      // Grab our JSON data values.
      var alertId = data[0]['ucws_site_alert_id'];
      var alertTimestamp = data[0]['ucws_site_alert_timestamp'];
      var alertTitle = data[0]['ucws_site_alert_message'];

      // Add the alert to page.
      $('header').prepend(generateAlert(data[0]));

      // Newly added alert container.
      var $siteAlert = $('#global-alert');
      $('.link a', $siteAlert).addClass('read-more');

      // Add CSS so the alert is visible (initially minimized).
      $('body').addClass('site-alert');

      // Unique cookie name based on NID and saved/updated timestamp.
      var alertCookieName = cookieName + alertId + alertTimestamp;

      // Has the user seen this alert already and minimized it, or is
      // the user logged in (automatically close to access edit tabs)?
      var isAlertMinimized = (cookies.get(alertCookieName) === cookieHidden);
      var isUserLoggedIn = typeof drupalSettings !== 'undefined' &&
        typeof drupalSettings.user !== 'undefined' &&
        typeof drupalSettings.user.uid !== 'undefined' &&
        drupalSettings.user.uid > 0;

      // Maximize the alert.
      if (!isAlertMinimized && !isUserLoggedIn) {

        // Maximize the alert and change the tab to close button.
        $('.row.content', $siteAlert).slideDown();
        $('.row.controls .btn', $siteAlert).removeClass('btn-tab');

        // Set a cookie if the user minimizes the alert.
        $('.row.controls .btn', $siteAlert).on('click', function () {
          // Determine cookie expiry date.
          var oneDayFromNow = new Date();
          oneDayFromNow.setTime(oneDayFromNow.getTime() + (60 * 60 * 24000));
          // Determine the domain setting to allow site-wide dismiss.
          var cookieDomain = '';
          if (window.location.hostname.indexOf('ucalgary.ca') > -1) {
            cookieDomain = 'ucalgary.ca';
          }
          cookies.set(alertCookieName, cookieHidden, {
            expires: oneDayFromNow,
            sameSite: 'None',
            secure: true,
            domain: cookieDomain
          });
        });
      }

      // Initialize toggle function for the display of the alert.
      $('.row.controls .btn', $siteAlert).on('click', function () {
        $('.row.content', $siteAlert).slideToggle();
        $(this).toggleClass('btn-tab');
      });
    }
  });

})(jQuery, Drupal, drupalSettings, window.Cookies);
